import PageLayout from '@layouts/PageLayout/PageLayout';
import type { JSX } from 'react';

export function PersonalPolicyPage(): JSX.Element {
  return <PageLayout>Политика обработки персональных данных</PageLayout>;
}
